import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import CompetitionQuestionLayout from './competition-question-layout';

class CompetitionQuestionComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render = () => {
        ReactDOM.render(
            <CompetitionQuestionLayout options={this.options} />,
            this.element
        );
    }
}

export default CompetitionQuestionComponent;
